import { OverlayPositionBuilder } from './../overlay/position/overlay-position-builder';
import {
	overlay,
	Overlay,
	OriginConnectionPosition,
	OverlayConnectionPosition,
} from '@opten/overlay';
import { createNode } from '@opten/dom/create-node';

const transitionDuration = 300;

export class Tooltip {
	private _overlayRef: Overlay;
	private _tooltipOpen = false;

	private _cachedTitleTag: string;

	constructor(private _element: HTMLElement) {
		if (!_element.hasAttribute('title') || !_element.title) {
			return;
		}

		this._init();
	}

	private _init() {
		this._cachedTitleTag = this._element.title;

		if (!this._cachedTitleTag) {
			return;
		}

		this._element.addEventListener('mouseenter', () => this._show());
		this._element.addEventListener('mouseleave', () => this._hide());
	}

	private _show(): void {
		if (this._tooltipOpen) {
			return;
		}

		// prevent animating the title tag
		this._element.removeAttribute('title');

		this._tooltipOpen = true;
		this._createOverlay().open();
	}

	private _hide(): void {
		if (this._tooltipOpen) {
			this._tooltipOpen = false;

			this._overlayRef.close();
		}
	}

	/**
	 * This method creates the overlay from the provided tooltip's template and saves its
	 * OverlayRef so that it can be attached to the DOM when open is called.
	 */
	private _createOverlay(): Overlay {
		if (!this._overlayRef) {
			const portalElement = `<div class="c-tooltip">
                ${this._cachedTitleTag}
            </div>`;

			const origin = this._getOrigin();
			const overlayPosition = this._getOverlayPosition();

			// todo: like angular material this._overlayRef.position()?
			// Create connected position strategy that listens for scroll events to reposition.
			const strategy = new OverlayPositionBuilder()
				.connectedTo(this._element, origin.main, overlayPosition.main)
				.withFallbackPosition(origin.fallback, overlayPosition.fallback);

			/*strategy.onPositionChange = (change) => {
                if (change.scrollableViewProperties.isOverlayClipped && this._tooltipInstance.isVisible()) {
                    this.hide(0)
                  } else {
                    // Otherwise recalculate the origin based on the new position.
                    this._tooltipInstance._setTransformOrigin(change.connectionPair);
                  }
            };*/

			this._overlayRef = overlay(createNode(portalElement), {
				positionStrategy: strategy,
				overlayClassName: 'c-tooltip__panel',
				hasBackdrop: false,
			});

			this._overlayRef.afterClosed = () => {
				this._overlayRef.dispose();

				// add title tag again
				this._element.setAttribute('title', this._cachedTitleTag);
			};
		}

		return this._overlayRef;
	}

	private _getOrigin() {
		// at the moment we only support above
		return {
			main: {
				originX: 'center',
				originY: 'top',
			} as OriginConnectionPosition,
			fallback: {
				originX: 'center',
				originY: 'bottom',
			} as OriginConnectionPosition,
		};
	}

	private _getOverlayPosition() {
		// at the moment we only support above
		return {
			main: {
				overlayX: 'center',
				overlayY: 'bottom',
			} as OverlayConnectionPosition,
			fallback: {
				overlayX: 'center',
				overlayY: 'top',
			} as OverlayConnectionPosition,
		};
	}
}

export function tooltip(element: HTMLElement): Tooltip {
	return new Tooltip(element);
}
